@if (port(); as port) {
  <div class="tabs__grid-item">
    <port-summary
      [service]="port"
      [subscriptionInstanceId]="subscriptionInstanceId()"
      [vlanranges]="vlanranges()"
      [forceTrafficBottom]="hasConfigurationDetails()"
      style="width: 100%"
    />
  </div>
}

@if (hasConfigurationDetails()) {
  <div class="tabs__grid-item">
    <div class="tabs__flex-center">
      <h3>{{ "ServiceElement.IPConfiguration" | translate }}</h3>
    </div>
    <div class="tabs__table">
      @if (bgpSessionPriority()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.BGPSessionPriority" | translate }}</div>
          <div class="tabs__table-col">{{ bgpSessionPriority() }}</div>
        </div>
      }
      @if (bgpExportPolicy()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.BGPExportPolicy" | translate }}</div>
          <div class="tabs__table-col">{{ bgpExportPolicy() }}</div>
        </div>
      }
      @if (bgpPassword()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.BGPPassword" | translate }}</div>
          <div class="tabs__table-col">{{ bgpPassword() }}</div>
        </div>
      }
      @if (isBgp()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.GracefulRestart" | translate }}</div>
          <div class="tabs__table-col">
            @if (auth.isSelfServiceEnabled && isInfrastructureDelegate()) {
              <span class="table-properties__flex" [class.table-properties__flex--blue]="gracefulRestart() === true">
                {{ gracefulRestart() | enabled_or_value }}
                <selfservice-toggle
                  [active]="gracefulRestart() === true"
                  [tooltipText]="'Selfservice.Tooltip.GracefulRestart' | translate"
                  (click)="selfServiceOpen.emit('graceful-restart')"
                />
              </span>
            } @else {
              {{ gracefulRestart() | enabled_or_value }}
            }
          </div>
        </div>
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.BFD" | translate }}</div>
          <div class="tabs__table-col">
            @if (auth.isSelfServiceEnabled && isInfrastructureDelegate()) {
              <span class="table-properties__flex" [class.table-properties__flex--blue]="bfd() === true">
                {{ bfd() | enabled_or_value }}
                <selfservice-toggle
                  [active]="bfd() === true"
                  [tooltipText]="'Selfservice.Tooltip.BFD' | translate"
                  (click)="selfServiceOpen.emit('bfd')"
                />
              </span>
            } @else {
              {{ bfd() | enabled_or_value }}
            }
          </div>
        </div>
        @if (sap().bfdMinimumInterval) {
          <div class="tabs__table-row">
            <div class="tabs__table-col">{{ "IP.BFDMinimalInterval" | translate }}</div>
            <div class="tabs__table-col">{{ sap().bfdMinimumInterval }}</div>
          </div>
        }
        @if (sap().bfdMultiplier) {
          <div class="tabs__table-row">
            <div class="tabs__table-col">{{ "IP.BFDMultiplier" | translate }}</div>
            <div class="tabs__table-col">{{ sap().bfdMultiplier }}</div>
          </div>
        }
      }
      @if (ipv4SurfIpAddress()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.SurfnetNeighborIPv4" | translate }}</div>
          <div class="tabs__table-col">{{ ipv4SurfIpAddress() }}</div>
        </div>
      }
      @if (ipv4ClientIpAddress()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.CustomerNeighborIPv4" | translate }}</div>
          <div class="tabs__table-col">{{ ipv4ClientIpAddress() }}</div>
        </div>
      }
      @if (ipv4Mtu()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.IPv4MTU" | translate }}</div>
          <div class="tabs__table-col">{{ ipv4Mtu() }}</div>
        </div>
      }
      @if (ipv6SurfIpAddress()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.SurfnetNeighborIPv6" | translate }}</div>
          <div class="tabs__table-col">{{ ipv6SurfIpAddress() }}</div>
        </div>
      }
      @if (ipv6ClientIpAddress()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.CustomerNeighborIPv6" | translate }}</div>
          <div class="tabs__table-col">{{ ipv6ClientIpAddress() }}</div>
        </div>
      }
      @if (ipv6Mtu()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.IPv6MTU" | translate }}</div>
          <div class="tabs__table-col">{{ ipv6Mtu() }}</div>
        </div>
      }
      @if (hasIpPrefixes()) {
        <div class="tabs__table-row">
          <div class="tabs__table-col">{{ "IP.IPPrefixes" | translate }}</div>
          <div class="tabs__table-col">
            <div class="tabs__overflow-box">
              @for (prefix of ipPrefixes(); track prefix) {
                <div class="tabs__overflow-box-item">{{ prefix }}</div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
